<template>
	<div style="width: 100%;height: 100%;">
		<iframe  :src="url" width="100%" height="100%"></iframe>
	</div>
</template>

<script>
	export default {
		props:{
			url:[Number,String],
			type:[Number,String]
		},
		mounted() {
			console.log(this.url)
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/homes/already/commponents/iform.vue